import { Badge as AntdBadge } from 'antd'
import {
  changeNotificationsParams,
  notificationSlice,
  resetNofifications,
} from 'shared/common/AllNotification/model/slice'
import { Icon } from 'shared/iconpack'
import clsx from 'shared/libs/clsx'
import { usePagesUpdate } from 'shared/libs/hooks/usePagesUpdate'

import { useEffect, useState } from 'react'

import Badge from 'shared/ui/Badge'
import { Button } from 'shared/ui/Button'
import Dropdown from 'shared/ui/Dropdown'
import { Spin } from 'shared/ui/Spin'

import useDynamicModuleLoader from 'shared/config/redux/hooks/useDynamicModuleLoader'
import { useAppDispatch } from 'shared/config/redux/hooks/useRedux'
import { palette } from 'shared/config/styles/palette'

import { useAllNotifications } from '../hooks/useAllNotifications'
import { useNotificationsCount } from '../hooks/useNotificationsCount'

import './Notification.css'

const AllNotificationBell = () => {
  const dispatch = useAppDispatch()
  useDynamicModuleLoader({
    reducers: {
      notification: notificationSlice,
    },
  })

  const [isOpenDropdown, setIsOpenDropdown] = useState<boolean>(false)

  const {
    notificationsData,
    isNotificationsFetching,
    loadingNotifications,
    currentPage,
    allPages,
  } = useAllNotifications({
    isOpenDropdown: isOpenDropdown,
  })
  const { unviewedNotifications, viewedNotifications } = useNotificationsCount()
  const { updateIsValid, resetPagesRelevance, refreshPageValidity } =
    usePagesUpdate({
      pages: allPages,
    })

  useEffect(() => {
    if (isOpenDropdown) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpenDropdown])

  useEffect(() => {
    if (
      currentPage &&
      updateIsValid &&
      updateIsValid[String(currentPage)] === false
    ) {
      dispatch(
        changeNotificationsParams({
          page: currentPage,
          limit: 10,
          isUpdate: true,
        }),
      )
      refreshPageValidity(String(currentPage))
    }
  }, [currentPage, updateIsValid])

  useEffect(() => {
    if (
      !(typeof unviewedNotifications === 'number') ||
      !(typeof viewedNotifications === 'number')
    )
      return
    if (isOpenDropdown) {
      resetPagesRelevance()
    } else {
      dispatch(resetNofifications())
    }
  }, [unviewedNotifications, viewedNotifications])

  return (
    <Dropdown
      trigger={['click']}
      menu={{ items: [...notificationsData, ...loadingNotifications] }}
      overlayClassName="allNotifications"
      open={isOpenDropdown}
      onOpenChange={setIsOpenDropdown}
      dropdownRender={(menu) => (
        <>
          <div className="flex items-center justify-between gap-4 p-4 pb-3">
            <div className="flex gap-2 items-center">
              <span className="text-dark leading-7 text-xl font-bold">
                Уведомления
              </span>
              {unviewedNotifications && unviewedNotifications > 0 ? (
                <Badge value={unviewedNotifications} />
              ) : null}
            </div>
            <Button
              className="h-auto p-1 !bg-light_gray_10 rounded-full border-none shadow-none"
              onClick={() => setIsOpenDropdown(false)}
            >
              <Icon
                name="boldClose"
                size={16}
                color={palette.white}
              />
            </Button>
          </div>
          {notificationsData?.length > 0 ? (
            menu
          ) : (
            <div className="flex justify-center mt-[50%] translate-y-[-50%]">
              {isNotificationsFetching ? (
                <Spin />
              ) : (
                <span className="text-gray leading-6 text-base">
                  У вас нет уведомлений
                </span>
              )}
            </div>
          )}
        </>
      )}
    >
      <Button className="h-auto p-0 px-[6px] border-none bg-transparent shadow-none">
        <AntdBadge
          dot={true}
          offset={[-5, 5]}
          color={palette.red_5}
          className={clsx(`notifcationBadge`, {
            ['hiddenBadge']: !unviewedNotifications,
          })}
        >
          <Icon
            name="bell"
            width={24}
            height={24}
            color={palette.light_gray_8}
          />
        </AntdBadge>
      </Button>
    </Dropdown>
  )
}

export default AllNotificationBell
